import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=07a65de4&scoped=true&"
import script from "./SettingsList.vue?vue&type=script&lang=js&"
export * from "./SettingsList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=07a65de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a65de4",
  null
  
)

export default component.exports